import { Plus } from 'lucide-react';
import type { GoalTaskBlock } from '@/entities/chat-message';

interface AddedTaskLineProps {
  task: GoalTaskBlock;
}

export function AddedTaskLine({ task }: AddedTaskLineProps) {
  return (
    <span className="text-xs text-gray-500">
      <Plus className="inline h-3.5 w-3.5 align-[-0.15em]" /> Added{' '}
      <span className="font-medium text-gray-700">{task.data.title}</span> to
      today{'\u2019'}s plan
    </span>
  );
}
